module.exports = __webpack_public_path__ + "static/IMG-20251103-092359-9ee5157730beb86e85fd4afb5c13d201.jpg";